var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatClear(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0982 2.39541C19.5659 1.8679 18.7035 1.86824 18.1716 2.39615L12.0377 8.48407L11.7589 8.20746C10.423 8.91711 9.01767 9.47541 7.51529 9.72385C5.70145 10.0238 3.87484 10.1464 2.03794 10.1464C1.52092 16.3024 6.35296 21.5219 12.6021 20.9582L12.8202 20.5254C13.5139 19.1489 14.1886 17.1304 14.6816 15.4999C15.0269 14.3579 15.3417 13.2081 15.6335 12.0518L15.4664 11.886L21.6013 5.79716C22.1333 5.26901 22.1328 4.41276 21.6004 3.88498L20.0982 2.39541ZM13.276 9.71265L14.2282 10.6574L20.0879 4.8416L19.1354 3.89712L13.276 9.71265ZM9.3924 11.0718L13.0841 14.7347C13.3531 13.8321 13.5659 13.0522 13.6909 12.5815L11.4191 10.3274C10.9555 10.5344 10.2492 10.8217 9.3924 11.0718ZM12.4945 16.6069L7.35584 11.5083C5.83853 11.7368 4.50898 11.8258 3.69411 11.861C3.80597 15.9923 7.58011 19.3571 11.4691 19.2974C11.821 18.5222 12.1728 17.5695 12.4945 16.6069Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 16L1.27009 16.7299L2 17L1.27009 17.2701L1 18L0.729909 17.2701L0 17L0.729909 16.7299L1 16Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 18L3.17523 19.8248L5 20.5L3.17523 21.1752L2.5 23L1.82477 21.1752L0 20.5L1.82477 19.8248L2.5 18Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatClear);
export default __webpack_public_path__ + "static/media/chat_clear.556983c84c9122b2e43bc3c5c866bf18.svg";
export { ForwardRef as ReactComponent };